import getScriptJs from 'ha/helpers/scriptjsWrapper';

const STRIPE_SCRIPT = 'https://js.stripe.com/v2/';

export const initStripe =
  () =>
  (_, __, { stripe }) =>
    stripe.init();

export default config => {
  let initializedP;

  return {
    init: () => {
      if (initializedP) {
        return initializedP;
      }

      initializedP = getScriptJs(STRIPE_SCRIPT)
        .then(() => {
          if (global.Stripe) {
            return global.Stripe;
          }

          throw new Error('loading error');
        })
        .then(stripe => {
          stripe.setPublishableKey(config.stripe.apiToken);

          return stripe;
        })
        .catch(err => {
          initializedP = null;
          throw err;
        });

      return initializedP;
    },
  };
};
